class HapticService {
  vibrate = () => {
    try {
      window.Telegram?.WebApp.HapticFeedback.impactOccurred('medium')
    } catch (e) {
      console.warn('Haptic feedback failed', e)
    }
  }

  vibrateSuccess = () => {
    try {
      window.Telegram?.WebApp.HapticFeedback.impactOccurred('heavy')
    } catch (e) {
      console.warn('Haptic feedback failed', e)
    }
  }
}

export const hapticService = new HapticService()
